/**
 * JWT refresh threshold in seconds (40 minutes)
 * Token is considered stale after this time from issuance
 */
export const JWT_REFRESH_THRESHOLD_SECONDS = 60 * 40;

/**
 * Buffer before expiry in seconds (1 minute)
 * A token with less time left can fail on later backend calls (server time differences, consecutive services)
 */
export const JWT_EXPIRY_BUFFER_SECONDS = 60;
